import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { LinkService } from '../../_services/langhfre.service';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT, isPlatformServer } from '@angular/common';

@Component({
  selector: 'app-es-editor',
  templateUrl: './es-editor.component.html',
  styleUrls: ['./es-editor.component.scss']
})
export class EsEditorComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    private _renderer2: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private _document: Document, 
  ) { }

  ngOnInit(): void {
      this.titleService.setTitle('Free Spanish Grammar Checker Online – Trinka AI');
      this.metaTagService.updateTag({ name: 'description', content: "Improve your Spanish writing with Trinka AI’s free Spanish grammar checker. Instantly fix Spanish grammar, spelling, and style errors for clear and accurate text." });
      this.metaTagService.updateTag({ property: 'og:title', content: 'Free Spanish Grammar Checker Online – Trinka AI' });
      this.metaTagService.updateTag({ property: 'og:description', content: "Improve your Spanish writing with Trinka AI’s free Spanish grammar checker. Instantly fix Spanish grammar, spelling, and style errors for clear and accurate text." });
      this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/spanish-grammar-checker' });
      this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
      this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/free-spanish-grammar-checker.png' });
      this.metaTagService.updateTag({ name: 'twitter:title', content: 'Free Spanish Grammar Checker Online – Trinka AI' });
      this.metaTagService.updateTag({ name: 'twitter:description', content: "Improve your Spanish writing with Trinka AI’s free Spanish grammar checker. Instantly fix Spanish grammar, spelling, and style errors for clear and accurate text." });
      this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/free-spanish-grammar-checker.png' });
      this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
      this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/spanish-grammar-checker' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/spanish-grammar-checker' });
      // this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/spanish-grammar-checker' });
      // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/spanish-grammar-checker' });
      // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/spanish-grammar-checker' });
      // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/spanish-grammar-checker' });
      // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/spanish-grammar-checker' });
      // this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/spanish-grammar-checker' });
      // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/spanish-grammar-checker' });

      if (isPlatformServer(this.platformId)) {
        const script = this._renderer2.createElement('script');
        script.type = 'application/ld+json';
        script.text = `{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Trinka: corrector gramatical para la escritura académica y técnica","item":"https://www.trinka.ai/es/"},{"@type":"ListItem","position":2,"name":"Corrector ortográfico gratuito en línea – IA de Trinka","item":"https://www.trinka.ai/spanish-grammar-checker"}]}`
        this._renderer2.appendChild(this._document.head, script);
  
        const script1 = this._renderer2.createElement('script');
        script1.type = 'application/ld+json';
        script1.text = `{"@context":"https://schema.org","@graph":[{"@type":"WebSite","@id":"https://www.trinka.ai/spanish-grammar-checker#website","name":"Free Spanish Grammar Checker Online – Trinka AI","url":"https://www.trinka.ai/spanish-grammar-checker","description":" Improve your Spanish writing with Trinka AI’s free Spanish grammar checker. Instantly fix Spanish grammar, spelling, and style errors for clear and accurate text."},{"@type":"WebPage","@id":"https://www.trinka.ai/spanish-grammar-checker#webpage","url":"https://www.trinka.ai/spanish-grammar-checker","name":" Free Spanish Grammar Checker Online – Trinka AI","description":" Improve your Spanish writing with Trinka AI’s free Spanish grammar checker. Instantly fix Spanish grammar, spelling, and style errors for clear and accurate text.","isPartOf":{"@id":"https://www.trinka.ai/spanish-grammar-checker#website"}}]}`
        this._renderer2.appendChild(this._document.head, script1);
      }
    }

    ngAfterViewInit() {
      const observer = new MutationObserver(() => {
        const editors = document.querySelectorAll('.editor');
    
        editors.forEach((editor) => {
          editor.setAttribute('data-gramm', 'false');
          editor.setAttribute('data-gramm_editor', 'false');
          editor.setAttribute('data-enable-grammarly', 'false');
        });
      });
    
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

  selectedTab: 'english' | 'spanish' = 'english';

  selectTab(tab: 'english' | 'spanish'): void {
    this.selectedTab = tab;
  }

}
